import { SECTION_PATHS } from 'constants/index';

export const navItems = [
    {
        path: SECTION_PATHS.HOME,
        text: 'navigation.nav-items.home',
    },
    {
        path: SECTION_PATHS.SYSTEM,
        text: 'navigation.nav-items.system',
    },
    {
        path: SECTION_PATHS.FUNCTIONS,
        text: 'navigation.nav-items.functions',
    },
    {
        path: SECTION_PATHS.SERVICE,
        text: 'navigation.nav-items.service',
    },
    {
        path: SECTION_PATHS.ABOUT_US,
        text: 'navigation.nav-items.about-us',
    },
];
